export const MetaMaskIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.428 21.8907L17.2587 20.3827L13.36 22.6653H10.64L6.73867 20.3827L1.572 21.8893L0 16.6933L1.572 10.924L0 6.04533L1.572 0L9.64667 4.72533H14.3533L22.428 0L24 6.04533L22.428 10.9227L24 16.6933L22.428 21.8907Z"
      fill="#FF5C16"
    />
    <path
      d="M1.57324 0L9.64658 4.72933L9.32658 7.97467L1.57324 0ZM6.73991 16.6933L10.2932 19.3467L6.73991 20.3827V16.6933ZM10.0092 12.312L9.32658 7.97733L4.95591 10.924H4.95324V10.9253L4.96658 13.9587L6.73991 12.312H10.0092ZM22.4266 0L14.3519 4.72933L14.6719 7.97467L22.4266 0ZM17.2599 16.6933L13.7066 19.3467L17.2599 20.3827V16.6933ZM19.0452 10.9253L14.6732 7.97867L13.9906 12.312H17.2586L19.0319 13.96L19.0452 10.9253Z"
      fill="#FF5C16"
    />
    <path
      d="M6.73867 20.3827L1.572 21.8893L0 16.696H6.73867V20.3827ZM10.008 12.3107L10.9947 18.5773L9.62667 15.092L4.964 13.9587L6.73733 12.3107H10.008ZM17.2613 20.3827L22.428 21.8893L24 16.696H17.26L17.2613 20.3827ZM13.992 12.3107L13.0053 18.5773L14.3733 15.092L19.036 13.9587L17.2613 12.3107H13.992Z"
      fill="#E34807"
    />
    <path
      d="M0 16.6933L1.572 10.9227H4.952L4.96533 13.9573L9.62667 15.0907L10.9947 18.5747L10.292 19.3427L6.73867 16.6907H0V16.6933ZM24 16.6933L22.428 10.9227H19.048L19.0347 13.9573L14.3733 15.0907L13.0053 18.5747L13.708 19.3427L17.2613 16.6907H24V16.6933ZM14.3533 4.72534H9.64667L9.32667 7.97201L10.9947 18.572H13.0053L14.6747 7.97201L14.3533 4.72534Z"
      fill="#FF8D5D"
    />
    <path
      d="M1.572 0L0 6.04533L1.572 10.9227H4.952L9.32533 7.97467L1.572 0ZM9.03067 13.5693H7.5L6.66533 14.3693L9.628 15.0893L9.03067 13.5693ZM22.428 0L24 6.04533L22.428 10.9227H19.048L14.6747 7.97467L22.428 0ZM14.9707 13.5693H16.504L17.3387 14.3693L14.3733 15.0907L14.9707 13.5693ZM13.3587 20.5973L13.708 19.344L13.0053 18.5773H10.9933L10.2907 19.344L10.64 20.5973"
      fill="#661800"
    />
    <path
      d="M13.3599 20.5974V22.6667H10.6399V20.5974H13.3599Z"
      fill="transparent"
    />
    <path
      d="M6.73999 20.38L10.6427 22.6653V20.596L10.2933 19.3427L6.73999 20.38ZM17.26 20.38L13.36 22.6667V20.5973L13.7093 19.344L17.26 20.38Z"
      fill="transparent"
    />
  </svg>
);
